import type { FAQItem } from "@/landing/lib/types";

export const LINKEDIN_FAQ_ITEMS: FAQItem[] = [
  {
    question: "How does it work?",
    answer:
      "Download the CLI, then ask Claude what you can do. Pretty much almost everything you're doing manually.",
  },
  {
    question: "Is it free?",
    answer:
      "No. One plan, $49.99/mo, paired with the best anti-detect, for unlimited actions. AI generation is billed per use at cost.",
  },
  {
    question: "Are my accounts safe?",
    answer:
      "We have the best anti-detect browser on the market, built specifically for social media automations. You still need to be mindful of the platforms' own limits and respectful of their T&Cs.",
  },
  {
    question: "Can I use this with Claude Code or Cowork?",
    answer:
      "You can use this with Claude Code today. We will be releasing an MCP soon that you'll be able to use with Claude Cowork.",
  },
  {
    question: "Can I whitelabel this?",
    answer:
      "Contact us for any whitelabelling. If you're an agency that wants to set up automations for your clients and have visibility over those, reach us at contact@wonda.sh for dedicated, affordable agency plans.",
  },
  {
    question: "What if my account gets restricted?",
    answer:
      "We minimize risk with native behavior on real devices and the highest-quality anti-detect. Restrictions may still happen if you do not respect the social platforms' T&Cs and fair-use policies.",
  },
  {
    question: "What countries are you live in?",
    answer:
      "You can use Wonda anywhere in the world. Questions? Contact us at contact@wonda.sh.",
  },
  {
    question: "Do I need Claude Code?",
    answer:
      "You need an agent harness to make this work. We're compatible with Claude Code, Codex, OpenClaw, Hermes, Opencode and many others. If you'd like to access Wonda via Claude Cowork, get priority access below.",
    priorityAccessSource: "feature_MCP",
  },
  {
    question: "Do you have your own automations?",
    answer:
      "You can create your own automations using your Claude, Codex, or OpenClaw. To access ready-made automations, get priority access below.",
    priorityAccessSource: "readyMadeAutomations",
  },
  {
    question: "Can I use your API to plug in my workflows?",
    answer:
      "Yes. Wonda has a CLI and an API you can plug into your existing workflows. Automations run on your own machine, so your laptop needs to stay open while they run.",
  },
];
